import { BlueprintDeploymentState } from "types/generated";

export const isDeploymentUpdateDisabled = (state: BlueprintDeploymentState): boolean => {
  return [
    BlueprintDeploymentState.Destroying,
    BlueprintDeploymentState.InProgress,
    BlueprintDeploymentState.Unconfirmed,
    BlueprintDeploymentState.None,
  ].includes(state);
};

export const getUpdateDisabledTooltip = (state: BlueprintDeploymentState): string | undefined => {
  switch (state) {
    case BlueprintDeploymentState.Destroying:
      return "Cannot update deployment while it is being destroyed";
    case BlueprintDeploymentState.InProgress:
      return "Cannot update deployment while it is in progress";
    case BlueprintDeploymentState.Unconfirmed:
      return "Cannot update deployment while it is unconfirmed";
    case BlueprintDeploymentState.None:
      return "Cannot update deployment while it is in progress";
    case BlueprintDeploymentState.DestroyingFailed:
    case BlueprintDeploymentState.Discarded:
    case BlueprintDeploymentState.Failure:
    case BlueprintDeploymentState.Finished:
      return undefined;
  }
};
